import { useEffect, useState } from "react";
import icon1 from "./assets/icon1.png";
import { useLocation } from "react-router-dom";
import axios from "axios";

import { authApi } from "@/api/api";
import { toast } from "react-toastify";
import { billingApi } from "@/api/billingApi";
import { ensurePhoneNumberFormat } from "@/utils/phoneNumberUtils";

interface CallPackage {
  currency: string;
  fee_per_overage_minute: number;
  id: string;
  minutes: number;
  name: string;
  price: number;
  recurring: {
    interval: string;
    interval_count: number;
  };
  type: string;
}

const SelectSubscription = () => {
  const location = useLocation();
  const { selectedNumber, selectedType } = location.state || {};

  const [callPackages, setCallPackages] = useState<CallPackage[]>([]);
  const [selectedPackageIndex, setSelectedPackageIndex] = useState(0);
  const [selectedMinutes, setSelectedMinutes] = useState(0);
  const price = (selectedMinutes * 1.56).toFixed(2);

  useEffect(() => {
    console.log("selectedNumber", selectedNumber);
    console.log("selectedType", selectedType);
    async function fetchPackages() {
      try {
        const packageType =
          selectedType === "toll_free" ? "toll_free" : "regular";

        const response = await authApi.getPackages(packageType);
        console.log("response", response.data);
        console.log("response", response.data.packages);
        setCallPackages(response.data.packages);
      } catch (error) {
        console.error("Error fetching packages:", error);
      }
    }
    fetchPackages();
  }, [selectedNumber, selectedType]);

  async function purchasePackage() {
    try {
      // Ensure phone number has proper format before sending to API
      const formattedPhoneNumber = ensurePhoneNumberFormat(selectedNumber);
      const { packagesApi } = await import("@/api/packagesApi");
      const response = await packagesApi.createReservation(
        callPackages[selectedPackageIndex].id,
        formattedPhoneNumber
      );
      console.log("response", response);
      console.log("response data", response.data.reservation_id);
      try {
        const subscriptionResponse = await billingApi.createSubscription(
          response.data.reservation_id
        );
        console.log("subscriptionResponse", subscriptionResponse);
        window.location.href = subscriptionResponse.data.url;
      } catch (error) {
        toast.error(`select subscription failed : ${error}`);
        console.error("Error creating subscription:", error);
      }

      // if (response.status === 200) {
      //   const checkout_session_url = response.data.checkout_session_url;
      //   console.log("checkout_session_url", checkout_session_url);
      //   window.location.href = checkout_session_url;
      // }
    } catch (error) {
      toast.error(`Error purchasing package: ${error}`);
      console.error("Error purchasing package:", error);
      if (axios.isAxiosError(error) && error.response) {
        console.error("Error details:", error.response.data);
      }
    }
  }

  const getBackgroundSize = () => {
    const min = 0;
    const max = callPackages.length - 1;
    const value = selectedPackageIndex;
    return { backgroundSize: `${((value - min) * 100) / (max - min)}% 100%` };
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-[#f3f5f6]">
      <div className="bg-white p-8 rounded-xl shadow-lg max-w-[800px] w-full">
        <img src={icon1} alt="icon1" />
        <h2 className="text-2xl font-semibold text-[#45474d] mb-2">
          Select your subscription
        </h2>
        <p className="text-sm text-[#7f828d] mb-6">
          After selecting a subscription, you can choose the number you want.
        </p>
        <div className="flex flex-col gap-10 bg-gradient-to-br from-[#00b67a] to-[#1dc7ff] p-6 rounded-2xl text-white text-center mb-6 w-1/2 mx-auto">
          <div className="text-xl font-bold text-start">${price}</div>
          <div className="text-6xl font-bold text-center">
            {selectedMinutes} min
          </div>
          <div className="text-sm text-end">
            ${callPackages[selectedPackageIndex]?.fee_per_overage_minute} per
            add. min
          </div>
        </div>

        <div className="relative w-full mb-8">
          {callPackages.length > 0 ? (
            <>
              <style>
                {`
                  input[type="range"] {
                    -webkit-appearance: none;
                    background-color: #edeff7;
                    border-radius: 8px;
                    height: 4px;
                    width: 100%;
                    background-image: linear-gradient(#0cb17b, #0cb17b);
                    background-repeat: no-repeat;
                  }

                  input[type="range"]::-webkit-slider-thumb {
                    -webkit-appearance: none;
                    height: 20px;
                    width: 20px;
                    border-radius: 50%;
                    background: #0cb17b;
                    cursor: pointer;
                    box-shadow: 0 0 2px 0 rgb(0 0 0 / 10%);
                  }

                  input[type="range"]::-webkit-slider-runnable-track {
                    -webkit-appearance: none;
                    box-shadow: none;
                    border: none;
                    background: transparent;
                  }

                  .milestone {
                    width: 2px;
                    height: 10px;
                    background: #0cb17b;
                    position: absolute;
                    top: -3px;
                  }
                `}
              </style>
              <div className="relative">
                <input
                  aria-label="Package selector"
                  title="Package selector"
                  placeholder="Package selector"
                  type="range"
                  min={0}
                  max={callPackages.length - 1}
                  value={selectedPackageIndex}
                  onChange={(e) => {
                    const index = Number(e.target.value);
                    setSelectedPackageIndex(index);
                    setSelectedMinutes(callPackages[index].minutes);
                  }}
                  step={1}
                  style={getBackgroundSize()}
                  className="w-full"
                />
                {callPackages.map((_, index) => (
                  <div
                    aria-label="Package milestone"
                    title="Package milestone"
                    key={index}
                    className="milestone"
                    style={{
                      left: `${(index / (callPackages.length - 1)) * 100}%`,
                    }}
                  />
                ))}
              </div>
              <div className="flex justify-between mt-4">
                {callPackages.map((pkg, index) => (
                  <div
                    aria-label="Package selector"
                    title="Package selector"
                    key={pkg.id}
                    className={`text-xs ${
                      selectedPackageIndex === index
                        ? "text-[#0cb17b] font-bold"
                        : "text-[#aaacb3]"
                    }`}
                    style={{
                      position: "absolute",
                      left: `${(index / (callPackages.length - 1)) * 100}%`,
                      transform: "translateX(-50%)",
                    }}
                  >
                    {pkg.minutes}min
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className="text-center text-gray-500">Loading packages...</div>
          )}
        </div>

        <div className="flex justify-center">
          <button
            onClick={() => {
              purchasePackage();
            }}
            className="w-1/2 mx-auto text-center bg-[#0cb17b] text-white py-2 rounded-lg hover:bg-green-600"
          >
            Select
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectSubscription;
